import React, { useState, useRef } from "react";
import { Card, CardContent, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, Button } from "@deere/fuel-react";
import SelfServiceButtons from "../SelfServiceButtons";
import { ERR_DOCUMENT_FORMAT, ERR_DUPLICATE_FILE } from "../../../../utils/errorLiterals";
import { FILE_FORMAT_PDF, SAVING_DATA } from "../../../../utils/surveyLiterals";
import { ReactComponent as FileUploadIcon } from "@deere/ux.brand-foundations/icons/upload.svg";
import { validateHelpDocs } from "../../../../utils/validation";
import { sortByLanguageList } from "../../../../utils/utils";
import SelfServiceLoader from "../SelfServiceLoader";

const HelpDocStep = ({ helpDocError, setHelpDocError, currentStep, activeStep, setActiveStep, setPayloadData, payloadData, languageList }) => {
  const fileInputref = useRef([]);
  const [loader, setLoader] = useState({isLoading: false, message: ""});

  const fnValidate = (publishHandler) => {
    const error = validateHelpDocs(payloadData);
    error.show
    ? setHelpDocError(error)
    : (setLoader({ isLoading: true, message: SAVING_DATA }), publishHandler(payloadData));
  };

  const fileUploadHandler = (event) => {
    event.preventDefault();
    setHelpDocError({ show: false, message: "" });
    const fileName = event.target.files[0].name;
    const extension = fileName.split(".")[fileName.split(".").length - 1];
    const docLanguage = event.target.name.split("~")[1];
    const docNames = payloadData && payloadData.helpDocs ? payloadData.helpDocs.map((hd) => hd.docName) : [];
    if (extension !== FILE_FORMAT_PDF) {
      setHelpDocError({ show: true, message: ERR_DOCUMENT_FORMAT });
      event.target.value = null;
    } else if (docNames.includes(fileName)) {
      setHelpDocError({ show: true, message: ERR_DUPLICATE_FILE });
      event.target.value = null;
    } else {
      setPayloadData((prevState) => {
        const helpDocs = [...prevState.helpDocs];
        const index = helpDocs.findIndex((hd) => hd.languageCd?.split('_')[0].toLowerCase() === docLanguage?.split('_')[0].toLowerCase());
        if (index > -1) {
          helpDocs[index].docName = fileName;
          helpDocs[index].file = event.target.files[0];
          helpDocs[index].isNewUpload = true;
        } else {
          helpDocs.push({languageCd: docLanguage, docName: fileName, file: event.target.files[0], isNewUpload: true});
        }
        return { ...prevState, helpDocs: helpDocs };
      });
    }
    if (extension !== "pdf" || docNames.includes(fileName)) {
      setPayloadData((prevState) => {
        const helpDocs = [...prevState.helpDocs];
        const index = helpDocs.findIndex((hd) => hd.languageCd === docLanguage);
        if (index > -1) {
          helpDocs[index].docName = "";
          helpDocs[index].file = null;
        }
        return { ...prevState, helpDocs: helpDocs };
      });
    }
  };

  const clickHandler = (langCd) => {
    fileInputref.current.value = "";
    fileInputref.current[langCd].click();
  };

  const getDocName = (langCd) => {
    if (payloadData && payloadData.helpDocs) {
      const index = payloadData.helpDocs.findIndex((hd) => hd.languageCd?.split("_")[0].toLowerCase() === langCd?.split("_")[0].toLowerCase());
      return index > -1 ? payloadData.helpDocs[index].docName : "";
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          {loader.message !== "" && <SelfServiceLoader loader={loader} />}
          {loader.message === "" && <Grid container direction="column" justifyContent="space-between" rowSpacing={4} minHeight={"70vh"}>
            <Grid item>
              <Typography variant="h1" mb={2}>
                {currentStep.step} - {currentStep.title}
              </Typography>
              <Typography variant="subtitle">Help documents can be uploaded here for this survey to assist the supplier in providing the necessary information.</Typography>
            </Grid>
            <Grid item>
              <Table size="small">
                <TableHead sx={{ border: "none" }}>
                  <TableRow>
                    <TableCell width={"20%"}></TableCell>
                    <TableCell width={"60%"}>Help Document</TableCell>
                    <TableCell width={"20%"}>Language</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortByLanguageList(payloadData.language, languageList).map((lang) => (
                    <TableRow key={lang.languageCd} sx={{ border: "none!important" }}>
                      <TableCell>
                        <input
                          type="file"
                          style={{ display: "none" }}
                          ref={(ref) => {
                            fileInputref.current[lang.languageCd] = ref;
                          }}
                          onChange={fileUploadHandler}
                          name={`helpDoc~${lang.languageCd}`}
                        />
                        <Button variant="secondary" startIcon={<FileUploadIcon />} onClick={() => clickHandler(lang.languageCd)}>
                          Upload File
                        </Button>
                      </TableCell>
                      <TableCell>{getDocName(lang.languageCd)}</TableCell>
                      <TableCell>{lang.text}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
            {helpDocError.show && (
              <Typography variant="subtitle1" color="#C21020" textAlign="right">
                {helpDocError.message}
              </Typography>
            )}
            <Grid item>
              <Grid container justifyContent="flex-end">
                <SelfServiceButtons
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  fnValidate={fnValidate}
                  payloadData={payloadData}
                  setPayloadData={setPayloadData}
                  setLoader={setLoader}
                />
              </Grid>
            </Grid>
          </Grid>}
        </CardContent>
      </Card>
    </>
  );
};

export default HelpDocStep;
